export default __webpack_public_path__ + "static/media/building1.d929d78d.png";